import { authHeaders, baseUrl, handleResponse } from "./apiUtils";

async function getClientPortal() {
  const response = await fetch(`${baseUrl}self-service/client-portal`, {
    headers: authHeaders(),
  });
  return handleResponse(response);
}

async function cancelLessonParticipation({ lessonId, studentId }) {
  const response = await fetch(
    `${baseUrl}self-service/client-portal/lessons/${encodeURIComponent(lessonId)}/cancel`,
    {
      method: "POST",
      headers: authHeaders({ "content-type": "application/json" }),
      body: JSON.stringify({ studentId }),
    },
  );
  return handleResponse(response);
}

async function undoLessonCancellation({ lessonId, studentId }) {
  const response = await fetch(
    `${baseUrl}self-service/client-portal/lessons/${encodeURIComponent(lessonId)}/undo-cancellation`,
    {
      method: "POST",
      headers: authHeaders({ "content-type": "application/json" }),
      body: JSON.stringify({ studentId }),
    },
  );
  return handleResponse(response);
}

export default {
  getClientPortal,
  cancelLessonParticipation,
  undoLessonCancellation,
};
